module.exports = __webpack_public_path__ + "img/no-data.f6a13035.jpg";